// platform goi_common의 동명 훅과 동일 구현 (실험 인프라 컨벤션 맞춤).
// 실제로는 순수 함수지만 platform 호출부와 이름을 맞추기 위해 use* 유지.
// localhost dev + Vercel preview 배포에서 true. NEXT_PUBLIC_IS_PRODUCTION=true면 강제 false.
export const useIsDevEnvironment = () => {
  const isDevelopment = process.env.NODE_ENV === "development";
  const isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";
  const isProductionExplicitlySet =
    process.env.NEXT_PUBLIC_IS_PRODUCTION === "true";

  return (isDevelopment || isPreview) && !isProductionExplicitlySet;
};
